/**
 * Reads a property whose name is only known at runtime. Column and field names
 * come off configuration as plain strings, and the interfaces they read from
 * have no index signature, so `value[name]` does not compile. Reflect reads a
 * key off a type without one.
 */
export const readField = (value: object, name: string): unknown =>
  Reflect.get(value, name);

/** The same read, narrowed to what a cell can render. */
export const readFieldText = (
  value: object,
  name: string,
): string | number | undefined => {
  const field = readField(value, name);
  return typeof field === 'string' || typeof field === 'number'
    ? field
    : undefined;
};
